import React, { useEffect, useState, useRef } from "react";
import vs1 from '../../assets/images/photos/vs-1.jpg'
import vs2 from '../../assets/images/photos/vs-2.jpg'
import vs3 from '../../assets/images/photos/vs-3.jpg'
import ana1 from '../../assets/images/photos/ana1.jpeg'
import ana2 from '../../assets/images/photos/ana2.jpeg'
import nao1 from '../../assets/images/photos/nao1.jpeg'
import nao2 from '../../assets/images/photos/nao2.jpeg'
import './About.css'

const About = () => {

    const [currentItem, setCurrentItem] = useState(0);
    const sectionRef = useRef(null);

    const images = [
        { image: vs1, name: 1 },
        { image: vs2, name: 2 },
        { image: vs3, name: 3 },
        { image: ana1, name: 4 },
        { image: ana2, name: 5 },
        { image: nao1, name: 6 },
        { image: nao2, name: 7 }
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentItem((prevItem) => (prevItem + 1) % images.length);
        }, 3000);

        return () => clearInterval(interval);
    }, [images.length]);


    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("transition-in-side");
                    } else {
                        entry.target.classList.remove("transition-in-side");
                    }
                });
            },
            { threshold: 0.5 }
        );

        const currentSection = sectionRef.current;

        if (currentSection) {
            observer.observe(currentSection);
        }

        return () => {
            if (currentSection) {
                observer.unobserve(currentSection);
            }
        };
    }, []);


    return (
        <div className="overflow-x-hidden">
            <div className="flex items-center gap-4 justify-center">
                <h2
                    className="font-title text-center text-5xl font-bold tracking-widest text-secondary"
                > NOSOTROS </h2>
            </div>
            <div className="flex flex-col md:flex-row gap-16 sm:p-8 md:p-10 lg:p-12 xl:p-10 px-8 sm:px-6 md:px-10 lg:px-12 xl:px-10 relative">
                <p
                    className="font-body text-justify text-letter flex-1 mt-4 sm:text-center md:text-left"
                    // ref={sectionRef}
                    // transition-style="in:side:bottom-right"
                >
                    Vishuddha combina modernidad y sofisticación con un ambiente acogedor
                    y cuidadosamente diseñado para fomentar confianza y profesionalismo.
                    Es un estudio que destaca por su enfoque personalizado y su compromiso con el desarrollo
                    integral de cada modelo, promoviendo tanto el crecimiento personal como profesional.
                    Con una sólida base en innovación y tecnología, Vishuddha implementa herramientas avanzadas
                    para medir rendimientos y potenciar mejoras continuas. Su equipo experto,
                    con amplia experiencia en la industria, ofrece formación de alta calidad y
                    un acompañamiento humano que garantiza el éxito en cada etapa del proceso.
                </p>
                <div className="relative flex flex-1 justify-center items-center mt-4 sm:mt-8">
                    <img
                        src={images[currentItem].image}
                        alt={`Imagen ${images[currentItem].name}`}
                        className="roman w-full h-auto max-w-[400px] md:max-w-[500px] lg:max-w-[600px] xl:max-w-[700px] rounded-lg shadow-lg"
                    />
                </div>
            </div>
        </div>
    );
};

export default About;
